import { apiRequests } from "./apirequests";
import { clientcompliance } from "./clientcompliance";
import { actiDomain, apiDomain, zabbixDomain } from "./constants";
import { getUserSession, setUserSession } from "./localstorage";
import { fromGlpiDateToHtmlInputDate } from "../util/convert-date";

import api from "./api";
import axios from "axios";

const consumablesGroup = 539;

export const userService = {
  info,
  getAll,
  states,
  loginZabbix,
  problemsZabbix,
  AsingZabbixProblems,
  AsingZabbixUpdateItens,
  AsingZabbixEvents,
  AcknowledgeEventZabbix,
  ItemHistoryZabbix,
  AsingUpdateZabbixToken,
  AsingZabbixSiteInfo,
  changeEntity,
  searchTicketsByStatus,
  searchTicketsAproved,
  searchTicketsWaiting,
  searchEquipmentsByStatus,
  searchEquipmentsByType,
  getObject,
  getObjectItem,
  postObject,
  updateObject,
  getAllActives,
  addTicket,
  relateAssetToTicket,
  getTicketInfo,
  searchConsumableItem,
  solveTicket,
  getAllConsumables,
  drawConsumable,
  searchConsumableItemType,
  searchConsumableItemByType,
  getConsumableList,
  getConsumableItem,
  updateConsumable,
  getConsumableItemInfo,
  searchConsumableItemQuantity,
  getConsumableItemType,
  getManufacturer,
  getLocation,
  addConsumable,
  searchConsumableItemTotal,
  searchItilCategories,
  searchRequestType,
  approveTicket,
  AddTicketFollowUp,
  AddTicketTask,
  denyTicket,
  searchGeneric,
  searchGenericWithFilter,
  getTechniciansFromTicket,
  getUserInfo,
  getTechniciansByName,
  searchTicketsInfo,
  getUserList,
  getUserCategoriesCost,
  AddTicketCost,
  searchTicketCost,
  searchEquipmentTypes,
  searchEquipmentsByTypeSimple,
  drawConsumableItem,
  addConsumables,
  AsingZabbixInfoBySite,
  updateTicket,
  getHTML,
  getFTECsv,
};

function strip(html) {
  var doc = new DOMParser().parseFromString(html, "text/html");
  return doc.body.textContent || "";
}

async function getFTECsv({ start, end }) {
  const response = await api.get(`${apiDomain}/fte`, {
    params: {
      start,
      end,
    },
    responseType: "blob",
  });

  return response.data;
}

// Tickets from last year , but with only 10 being presented
function getDeviceList(token, quantity) {
  var item = [],
    total = 0;
  var j = 0;

  // return fetch(`${actiDomain}search/user?criteria[1][field]=20&criteria[1][searchtype]=contains&criteria[1][value]=Técnico&forcedisplay[0]=2&forcedisplay[1]=34&forcedisplay[2]=9&forcedisplay[3]=81&sort=9&order=ASC&get_hateoas=0&range=0-39999`)

  return api
    .get("vdc/rest/devices/list", { withCredentials: true })
    .then(handleResponse);
}

//ACTI Requests

async function getHTML(url, id) {
  try {
    const response = await api.get(url);
    return { response: response.data, id };
  } catch (e) {
    errors2.push(e);
  }
}

// ACTI profile information
async function info(token) {
  const userSwap = getUserSession() || {};

  const data = await api
    .get(`${actiDomain}getFullSession`)
    .then(handleResponse);
  const session = (data && data.session) || {};

  const userFromSession = {
    ...userSwap,
    username: session.glpiname,
    name: `${session.glpifirstname} ${session.glpirealname}`,
    firstName: session.glpifirstname,
    lastName: session.glpirealname,
    activeentity: session.glpiactive_entity,
    entitycompletename: session.glpiactive_entity_name,
    glpiactiveprofile: session.glpiactiveprofile.name,
    id: session.glpiID,
    activeEntities: session.glpiactiveentities_string
      .split(/, ?/)
      .map(a => Number(a.replace(/'/g, ""))),
    profileEntities: session.glpiactiveprofile.entities,
  };

  const user = clientcompliance.getDetails(userFromSession);

  setUserSession(user);

  return user;
}

// ACTI profile information
async function changeEntity(token, glpiid, entitycompletename) {
  let user = getUserSession();

  //Get Entities

  await api.post(`${actiDomain}changeActiveEntities/`, {
    entities_id: glpiid,
    is_recursive: true,
  });

  user.activeentity = glpiid;
  user.entitycompletename = entitycompletename;
  user = clientcompliance.getDetails(user);

  setUserSession(user);

  return glpiid;
}

// ACTI add ticket
async function addTicket(
  token,
  title,
  description,
  urgency,
  priority,
  status,
  type,
  category,
) {
  var response;
  var user = getUserSession();

  try {
    const ticket = await api.post(
      `${actiDomain}Ticket/`,
      apiRequests.createTicket(
        title,
        description,
        status,
        urgency,
        priority,
        type,
        category,
      ),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = ticket;
    // console.log(response.id)
  } catch (e) {
    errors.push(e);
  }
  return response;
}

// ACTI Solve Ticket
async function updateTicket(token, id, ticketInfo) {
  var response;

  try {
    const changeEntity = await api.put(
      `${actiDomain}ticket/`,
      apiRequests.updateTicket(id, ticketInfo),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function solveTicket(token, id, solution, materials, ticketInfo) {
  var response;

  try {
    const changeEntity = await api.put(
      `${actiDomain}ticket/`,
      apiRequests.solveTicket(id, solution, materials, ticketInfo),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function approveTicket(token, id) {
  var response;

  try {
    const changeEntity = await api.put(
      `${actiDomain}ticket/`,
      apiRequests.approveTicket(id),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function denyTicket(token, id, approvalPercent) {
  var response;

  try {
    const changeEntity = await api.put(
      `${actiDomain}ticket/`,
      apiRequests.denyTicket(id, approvalPercent),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function AddTicketFollowUp(token, id, comment) {
  var response;

  try {
    const changeEntity = await api.post(
      `${actiDomain}TicketFollowup/`,
      apiRequests.AddTicketFollowUp(id, comment),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function AddTicketTask(
  token,
  id,
  user_id,
  actiontime,
  date_begin,
  date_end,
) {
  var response;

  try {
    const changeEntity = await api.post(
      `${actiDomain}TicketTask/`,
      apiRequests.AddTicketTask(id, user_id, actiontime, date_begin, date_end),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Solve Ticket
async function AddTicketCost(
  token,
  id,
  name,
  comment,
  actiontime,
  cost_time,
  cost_fixed,
  cost_materials,
) {
  var response;

  try {
    const changeEntity = await api.post(
      `${actiDomain}TicketCost/`,
      apiRequests.AddTicketCost(
        id,
        name,
        comment,
        actiontime,
        cost_time,
        cost_fixed,
        cost_materials,
      ),
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Draw COnsumable
async function drawConsumable(token, consumableItem, allConsumables) {
  // Date '2020-02-28'
  const now = new Date();
  const day = ("0" + now.getDate()).slice(-2);
  const date =
    now.getFullYear() +
    "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) +
    "-" +
    day;

  var response = null;
  var requests = [];
  var completeRequest = {};

  for (var i = 0; i < consumableItem.length; i++) {
    for (var j = 0; j < allConsumables.length; j++) {
      // console.log(consumableItem[i].id);
      if (
        allConsumables[j].consumableitems_id == consumableItem[i].id &&
        consumableItem[i].selected > 0
      ) {
        consumableItem[i].selected = consumableItem[i].selected - 1;

        requests.push(
          apiRequests.drawConsumable(
            allConsumables[j].id,
            date,
            allConsumables[j].consumableitems_id,
            consumablesGroup,
          ),
        );
        // console.log(requests)
      }
    }
  }
  // console.log(requests)
  if (requests.length > 0) {
    completeRequest = { input: requests };
    // console.log(completeRequest)

    try {
      const changeEntity = await api.put(
        `${actiDomain}consumable/`,
        completeRequest,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-Token": token,
          },
        },
      );

      response = changeEntity;
    } catch (e) {
      errors.push(e);
    }
  }

  return response;
}

async function addConsumables(token, consumableItemID, quantity) {
  // Date '2020-02-28'
  const now = new Date();
  const day = ("0" + now.getDate()).slice(-2);
  const date =
    now.getFullYear() +
    "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) +
    "-" +
    day;

  var response = null;
  var requests = [];
  var completeRequest = {};
  var selectedQuantity = quantity;

  for (var i = 0; i < quantity; i++) {
    requests.push(apiRequests.addConsumables(consumableItemID));
    // console.log(requests)
  }
  // console.log(requests)
  if (requests.length > 0) {
    completeRequest = { input: requests };
    // console.log(completeRequest)

    try {
      const changeEntity = await api.post(
        `${actiDomain}consumable/`,
        completeRequest,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-Token": token,
          },
        },
      );

      response = changeEntity;
    } catch (e) {
      errors.push(e);
    }
  }

  return response;
}

async function drawConsumableItem(
  token,
  consumableItemID,
  allConsumables,
  quantity,
) {
  // Date '2020-02-28'
  const now = new Date();
  const day = ("0" + now.getDate()).slice(-2);
  const date =
    now.getFullYear() +
    "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) +
    "-" +
    day;

  var response = null;
  var requests = [];
  var completeRequest = {};
  var selectedQuantity = quantity;

  // console.log("ITEM")
  // console.log(consumableItem)
  // console.log("ALL")
  // console.log(allConsumables)
  for (var i = 0; i < quantity; i++) {
    for (var j = 0; j < allConsumables.length; j++) {
      if (
        allConsumables[j].consumableitems_id == consumableItemID &&
        selectedQuantity > 0
      ) {
        selectedQuantity = selectedQuantity - 1;

        requests.push(
          apiRequests.drawConsumable(
            allConsumables[j].id,
            date,
            allConsumables[j].consumableitems_id,
            consumablesGroup,
          ),
        );
      }
    }
  }
  // console.log(requests)
  if (requests.length > 0) {
    completeRequest = { input: requests };
    // console.log(completeRequest)

    try {
      const changeEntity = await api.put(
        `${actiDomain}consumable/`,
        completeRequest,
        {
          headers: {
            "Content-Type": "application/json",
            "Session-Token": token,
          },
        },
      );

      response = changeEntity;
    } catch (e) {
      errors.push(e);
    }
  }

  return response;
}

// ACTI Draw COnsumable
async function updateConsumable(token, item) {
  var response;
  var completeRequest = {};
  var comment =
    item.value +
    "|" +
    item.leadtime +
    "|" +
    item.auto +
    "|" +
    item.unity +
    "|" +
    item.supplier;

  // Date '2020-02-28'
  const now = new Date();
  const day = ("0" + now.getDate()).slice(-2);
  const date =
    now.getFullYear() +
    "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) +
    "-" +
    day;

  completeRequest = apiRequests.updateConsumable(
    item.id,
    item.name,
    item.ref,
    comment,
    item.date,
    item.min,
    item.location,
    item.fab,
    item.type,
  );
  // console.log(completeRequest)

  try {
    const changeEntity = await api.put(
      `${actiDomain}consumableitem/`,
      completeRequest,
      {
        headers: { "Content-Type": "application/json", "Session-Token": token },
      },
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI Draw COnsumable
async function addConsumable(token, item, entity) {
  // Date '2020-02-28'
  const now = new Date();
  const day = ("0" + now.getDate()).slice(-2);
  const date =
    now.getFullYear() +
    "-" +
    ("0" + (now.getMonth() + 1)).slice(-2) +
    "-" +
    day;

  var response;
  var requests = [];
  var completeRequest = {};
  var comment =
    item.value +
    "|" +
    item.leadtime +
    "|" +
    item.auto +
    "|" +
    item.unity +
    "|" +
    item.supplier;

  completeRequest = apiRequests.addConsumable(
    entity,
    item.name,
    item.ref,
    comment,
    item.min,
    item.type,
    item.location,
    item.fab,
  );
  // console.log(completeRequest)

  try {
    const changeEntity = await api.post(
      `${actiDomain}consumableitem/`,
      completeRequest,
    );

    response = changeEntity;
  } catch (e) {
    errors.push(e);
  }

  return response;
}

// ACTI relate ticket with asste
async function relateAssetToTicket(token, itemtype, items_id, tickets_id) {
  try {
    return await api.post(
      `${actiDomain}Item_Ticket/`,
      apiRequests.relateEquipment(itemtype, items_id, tickets_id),
    );
    // console.log(response.id)
  } catch (e) {
    errors.push(e);
  }
}

function getAllActives(token, itemtype) {
  return api
    .get(`${actiDomain}search/AllAssets`, {
      params: {
        "forcedisplay[0]": "6",
        "forcedisplay[1]": "2",
        range: "0-19999",
      },
    })
    .then(handleResponse)
    .then(data => {
      let glpiActives = [];

      for (let j = 0; j < data.data.length; j++) {
        if (data.data[j]["itemtype"] == itemtype || !itemtype) {
          glpiActives.push({
            name: data.data[j]["1"],
            tag: data.data[j]["6"],
            id: j,
            glpiid: data.data[j]["id"],
            itemtype: data.data[j]["itemtype"],
          });
        }
      }

      if (glpiActives.length == 0) {
        glpiActives = null;
      }
      return glpiActives;
    });
}

// ACTI add ticket
async function postObject(token, glpiobject, data) {
  try {
    return await api.post(`${actiDomain}${glpiobject}`, data);
  } catch (e) {
    errors.push(e);
  }
  return undefined;
}

// ACTI add ticket
async function updateObject(token, glpiobject, data) {
  try {
    return await api.put(`${actiDomain}${glpiobject}`, data);
  } catch (e) {
    errors.push(e);
  }
  return undefined;
}

function getObject(token, glpiobject, id, extra) {
  if (extra == null) {
    extra = "";
  }
  return api
    .get(`${actiDomain}${glpiobject}/${id}${extra}`)
    .then(handleResponse);
}

function getObjectItem(glpiobject, id, item, extra) {
  if (extra == null) {
    extra = "";
  }
  return api
    .get(`${actiDomain}${glpiobject}/${id}/${item}${extra}`)
    .then(handleResponse);
}

async function getTicketInfo(
  ticketId,
  { expandDropdowns = false, withDocuments = false },
) {
  if (!ticketId) {
    return;
  }

  return api
    .get(`${actiDomain}ticket/${ticketId}`, {
      params: {
        expand_dropdowns: expandDropdowns,
        with_documents: withDocuments,
      },
    })
    .then(({ data }) => ({
      id: data.id,
      title: data.name,
      content: strip(data.content).replace(/(<([^>]+)>)/gi, ""),
      date: fromGlpiDateToHtmlInputDate(data.date_creation),
      time_to_own: data.time_to_own && fromGlpiDateToHtmlInputDate(data.time_to_own),
      begin_date: data.date && fromGlpiDateToHtmlInputDate(data.date),
      due_date: data.time_to_resolve && fromGlpiDateToHtmlInputDate(data.time_to_resolve),
      solvedate: data.solvedate && fromGlpiDateToHtmlInputDate(data.solvedate),
      type: data.type,
      status: data.status,
      category: data.itilcategories_id,
      origin: data.requesttypes_id,
      approval: data.global_validation,
      approvalPercent: data.validation_percent,
      location:
        typeof data.locations_id === "string" && expandDropdowns
          ? data.locations_id
          : null,
      entity: data.entities_id,
      materials: data.materiais,
      modality: data.urgency,
      priority: data.impact,
      slas_id_tto: data.slas_id_tto,
      slas_id_ttr: data.slas_id_ttr,
      solution: strip(data.solution).replace(/(<([^>]+)>)/gi, ""),
      documents:
        (data._documents &&
          data._documents.map(doc => ({
            filename: doc.filename,
            filepath: `https://sgi.green4t.com/files/${doc.filepath}`,
            date: doc.date_creation,
          }))) ||
        [],
    }));
}

// Tickets from last year , but with only 10 being presented
function getAllConsumables(token) {
  var glpiConsumables = [];
  var totalConsumables = 0;
  var j = 0;

  return api
    .get(`${actiDomain}consumable`, {
      params: {
        "searchText[date_out]": "null",
        get_hateoas: "0",
        range: "0-19999",
      },
    })
    .then(handleResponse)
    .then(data => {
      for (j = 0; j < data.length; j++) {
        glpiConsumables.push({
          id: data[j]["id"],
          entity: data[j]["entities_id"],
          consumableitems_id: data[j]["consumableitems_id"],
        });
      }
      return glpiConsumables;
    });
}

// Tickets from last year , but with only 10 being presented
function getConsumableList(token, id) {
  var glpiConsumables = [];
  var totalConsumables = 0;
  var j = 0;

  return api
    .get(`${actiDomain}consumable`, {
      params: {
        "searchText[consumableitems_id]": id,
        get_hateoas: "0",
        is_deleted: "0",
        range: "0-39999",
        sort: "date_out",
        order: "ASC",
      },
    })
    .then(handleResponse)
    .then(data => {
      for (j = 0; j < data.length; j++) {
        if (data[j]["consumableitems_id"] == id) {
          glpiConsumables.push({
            id: data[j]["id"],
            entity: data[j]["entities_id"],
            consumableitems_id: data[j]["consumableitems_id"],
            date_in: data[j]["date_in"],
            date_out: data[j]["date_out"],
            itemtype: data[j]["itemtype"],
            items_id: data[j]["items_id"],
          });
        }
      }

      return glpiConsumables;
    });
}

async function getTechniciansFromTicket(ticketId) {
  const result = {
    techsIds: [],
  };

  const { data: res } = await api.get(`${actiDomain}search/ticket`, {
    params: {
      "criteria[1][field]": "2",
      "criteria[1][searchtype]": "equals",
      "criteria[1][value]": ticketId,
      "forcedisplay[0]": "5",
    },
  });

  if (!res.data || !res.totalcount) {
    return result;
  }

  const [ticket] = res.data;
  if (!ticket[5]) {
    return result;
  }
  
  if (Array.isArray(ticket[5])) {
    result.techsIds.push(...ticket[5]);
  } else {
    result.techsIds.push(ticket[5]);
  }

  return result;
}

async function getTechniciansByName(name) {
  const params = {
    criteria: [
      {
        field: 8,
        searchtype: "equals",
        value: 1,
      },
      {
        link: "AND",
        criteria: [
          {
            field: 9,
            searchtype: "contains",
            value: name,
          },
          {
            link: "OR",
            field: 34,
            searchtype: "contains",
            value: name,
          },
        ],
      },
    ],
    forcedisplay: [2, 34, 9, 81],
    sort: "9",
    order: "ASC",
    get_hateoas: "0",
    range: "0-39999",
  };

  const { data: res } = await api.get(`${actiDomain}search/user`, { params });

  if (res.totalcount === 0) {
    return [];
  }

  return res.data
    .filter(tech => tech[9] !== "" && tech[34] !== "")
    .map(tech => ({
      id: tech[2],
      name: `${tech[9]} ${tech[34]}`,
      title: tech[81],
    }));
}

// Tickets from last year , but with only 10 being presented
function searchTicketCost(token, quantity) {
  var item = [],
    total = 0;
  var j = 0;

  // return fetch(`${actiDomain}search/user?criteria[1][field]=20&criteria[1][searchtype]=contains&criteria[1][value]=Técnico&forcedisplay[0]=2&forcedisplay[1]=34&forcedisplay[2]=9&forcedisplay[3]=81&sort=9&order=ASC&get_hateoas=0&range=0-39999`)

  return api
    .get(`${actiDomain}search/TicketCost`, {
      params: {
        "forcedisplay[0]": "2",
        "forcedisplay[1]": "1",
        "forcedisplay[2]": "16",
        "forcedisplay[3]": "12",
        "forcedisplay[4]": "10",
        "forcedisplay[5]": "11",
        "forcedisplay[6]": "14",
        "forcedisplay[7]": "15",
        "forcedisplay[8]": "80",
        sort: "2",
        order: "DESC",
        get_hateoas: "0",
        range: `0-${quantity}`,
      },
    })
    .then(handleResponse)
    .then(data => {
      // console.log(data)
      total = data.totalcount;
      if (data.count > 0) {
        for (j = 0; j < data.data.length; j++) {
          item.push({
            id: data.data[j][2],
            name: data.data[j][1],
            cost_material: data.data[j][16],
            begin_date: data.data[j][12],
            end_date: data.data[j][10],
            actiontime: data.data[j][11],
            cost_time: data.data[j][14],
            cost_fixed: data.data[j][15],
            client: data.data[j][80],
          });
        }
      }

      return {
        item: item,
        total: total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function getUserList(token) {
  var item = [];
  var j = 0;

  return api
    .get(`${actiDomain}search/user`, {
      params: {
        "forcedisplay[0]": "2",
        "forcedisplay[1]": "34",
        "forcedisplay[2]": "9",
        "forcedisplay[3]": "81",
        sort: "9",
        order: "ASC",
        get_hateoas: "0",
        range: "0-39999",
      },
    })
    .then(handleResponse)
    .then(data => {
      // console.log(data)

      for (j = 0; j < data.data.length; j++) {
        if (data.data[j][9] != "" && data.data[j][34] != "") {
          item.push({
            id: data.data[j][2],
            name: data.data[j][9] + " " + data.data[j][34],
            hours: 0,
            title: data.data[j][81],
            cost: 0,
          });
        }
      }

      return item;
    });
}

async function getUserCategoriesCost() {
  const params = {
    searchText: {
      comment: ".",
    },
    sort: "id",
    order: "ASC",
    get_hateoas: "0",
    range: "0-39999",
  };

  const { data } = await api.get(`${actiDomain}UserTitle`, { params });

  return data.map(userCategory => ({
    id: userCategory.id,
    name: userCategory.name,
    cost:
      typeof userCategory.comment === "string"
        ? parseFloat(userCategory.comment.trim())
        : userCategory.comment,
  }));
}

function getUserInfo(token, id) {
  return api.get(`${actiDomain}user/${id}`).then(handleResponse);
}

// Tickets from last year , but with only 10 being presented
function getConsumableItem(token, id) {
  var item = {};
  var totalConsumables = 0;
  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "";

  return api
    .get(`${actiDomain}search/consumableitem`, {
      params: {
        "criteria[0][field]": "2",
        "criteria[0][searchtype]": "equals",
        "criteria[0][value]": id,
        "forcedisplay[0]": "1",
        "forcedisplay[1]": "2",
        "forcedisplay[2]": "34",
        "forcedisplay[3]": "4",
        "forcedisplay[4]": "23",
        "forcedisplay[5]": "9",
        "forcedisplay[6]": "17",
        "forcedisplay[7]": "19",
        "forcedisplay[8]": "3",
        "forcedisplay[9]": "8",
        "forcedisplay[10]": "16",
        "forcedisplay[11]": "201",
        range: "0-1",
        sort: "2",
        order: "DESC",
      },
    })
    .then(handleResponse)
    .then(data => {
      // console.log(data)

      if (data.totalcount > 0) {
        splited = data.data[0][16].split("|");
        if (splited.length >= 5) {
          value = splited[0];
          leadtime = splited[1];
          auto = splited[2];
          unity = splited[3];
          supplier = splited[4];
        }

        item = {
          id: data.data[0][2],
          name: data.data[0][1],
          ref: data.data[0][34],
          type: data.data[0][4],
          fab: data.data[0][23],
          used: data.data[0][17],
          new: data.data[0][19],
          location: data.data[0][3],
          min: data.data[0][8],
          comment: data.data[0][16],
          date: data.data[0][201],
          lastYear: 0,
          total: data.data[0][19] + data.data[0][17],
          value: value,
          leadtime: leadtime,
          auto: auto,
          unity: unity,
          supplier: supplier,
        };
      }

      return item;
    });
}

// Tickets from last year , but with only 10 being presented
function getConsumableItemInfo(token, id) {
  return api
    .get(`${actiDomain}consumableitem/${id}`)
    .then(handleResponse)
    .then(data => fromGlpiDateToHtmlInputDate(data.date_creation));
}

function getConsumableItemType(token) {
  var glpiConsumableItem = [];
  var totalConsumableItem = 0;

  return api
    .get(`${actiDomain}consumableitemtype/`, {
      sort: "name",
      order: "ASC",
      get_hateoas: "0",
      range: "0-39999",
    })
    .then(handleResponse)
    .then(data => {
      totalConsumableItem = data.length;

      if (data.length > 0) {
        for (var j = 0; j < data.length; j++) {
          glpiConsumableItem.push({
            id: data[j]["id"],
            name: data[j]["name"],
          });
        }
      }

      return {
        glpiConsumableItem: glpiConsumableItem,
        totalConsumableItem: totalConsumableItem,
      };
    });
}

function getManufacturer(token) {
  var glpiConsumableItem = [];
  var totalConsumableItem = 0;
  var j = 0;

  // console.log("TOKEN: "+token)

  return api
    .get(`${actiDomain}manufacturer/`, {
      params: {
        sort: "name",
        order: "ASC",
        get_hateoas: "0",
        range: "0-39999",
      },
    })
    .then(handleResponse)
    .then(data => {
      totalConsumableItem = data.length;

      if (data.length > 0) {
        for (var j = 0; j < data.length; j++) {
          glpiConsumableItem.push({
            id: data[j]["id"],
            name: data[j]["name"],
          });
        }
      }

      return {
        glpiConsumableItem: glpiConsumableItem,
        totalConsumableItem: totalConsumableItem,
      };
    });
}

function getLocation(token) {
  var glpiConsumableItem = [];
  var totalConsumableItem = 0;
  var j = 0;

  return api
    .get(`${actiDomain}location/`, {
      params: {
        sort: "name",
        order: "ASC",
        get_hateoas: "0",
        range: "0-39999",
      },
    })
    .then(handleResponse)
    .then(data => {
      // console.log(data);

      totalConsumableItem = data.length;

      if (data.length > 0) {
        for (var j = 0; j < data.length; j++) {
          glpiConsumableItem.push({
            id: data[j]["id"],
            name: data[j]["completename"],
          });
        }
      }

      return {
        glpiConsumableItem: glpiConsumableItem,
        totalConsumableItem: totalConsumableItem,
      };
    });
}

async function searchConsumableItem(token) {
  const { data: res } = await api.get(`${actiDomain}search/consumableitem`, {
    params: {
      "forcedisplay[0]": "2",
      "forcedisplay[1]": "19",
      "forcedisplay[2]": "1",
      "forcedisplay[3]": "80",
      "forcedisplay[4]": "4",
      "forcedisplay[5]": "16",
      range: "0-2000",
    },
  });

  if (res.totalcount > 0) {
    const data = res.data.map(consumable => {
      const [value] = consumable[16].split("|");

      return {
        id: consumable[2],
        name: consumable[1],
        quantity: consumable[19],
        selected: 0,
        type: consumable[4],
        value: value,
      };
    });

    return {
      data,
      total: res.totalcount,
    };
  }

  return {
    data: [],
    total: res.totalcount,
  };
}

// Tickets from last year , but with only 10 being presented
function searchConsumableItemTotal(token, type, page) {
  var listEquipments = [];
  var totalEquipments = 0;
  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "",
    create_date = "",
    consumption = "",
    detailedconsumption = [],
    swapcon = "";

  return api
    .get(`${actiDomain}search/consumableitem`, {
      params: {
        "forcedisplay[0]": "1",
        "forcedisplay[1]": "2",
        "forcedisplay[2]": "34",
        "forcedisplay[3]": "4",
        "forcedisplay[4]": "23",
        "forcedisplay[5]": "9",
        "forcedisplay[6]": "17",
        "forcedisplay[7]": "19",
        "forcedisplay[8]": "3",
        "forcedisplay[9]": "8",
        "forcedisplay[10]": "16",
        range: "0-999",
        sort: "1",
        order: "ASC",
      },
    })
    .then(handleResponse)
    .then(data => {
      var totalConsumables = data.totalcount;
      var listConsumables = [];

      if (totalConsumables > 0) {
        for (j = 0; j < data.data.length; j++) {
          splited = data.data[j][16].split("|");
          if (splited.length >= 7) {
            value = splited[0];
            leadtime = splited[1];
            auto = splited[2];
            unity = splited[3];
            supplier = splited[4];
            create_date = splited[5];
            consumption = splited[6];
            detailedconsumption = splited.slice(7, 20);
            swapcon = "";
            for (var k = 0; k < detailedconsumption.length; k++) {
              swapcon = swapcon + detailedconsumption[k] + ";";
            }
            detailedconsumption = swapcon;
          } else {
            if (splited.length >= 5) {
              value = splited[0];
              leadtime = splited[1];
              auto = splited[2];
              unity = splited[3];
              supplier = splited[4];
            }
          }

          listConsumables.push({
            id: data.data[j][2],
            name: data.data[j][1],
            ref: data.data[j][34],
            type: data.data[j][4],
            fab: data.data[j][23],
            used: data.data[j][17],
            // new:"10",
            new: data.data[j][19],
            total: parseInt(data.data[j][17]) + parseInt(data.data[j][19]),
            location: data.data[j][3],
            // min:"8",
            min: data.data[j][8],
            comment: data.data[j][16],
            value: value,
            leadtime: leadtime,
            auto: auto,
            unity: unity,
            supplier: supplier,
            create_date: create_date,
            consumption: consumption,
            detailedconsumption: detailedconsumption,
          });
        }
      }

      return {
        list: listConsumables,
        total: totalConsumables,
        type: type,
        page: page,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchItilCategories(token, filter = "") {
  var listEquipments = [];
  var totalEquipments = 0;
  const url = `${actiDomain}search/itilcategory`;
  let params = {
    "forcedisplay[0]": "2",
    "forcedisplay[1]": "14",
    "forcedisplay[2]": "1",
    "forcedisplay[3]": "13",
    "forcedisplay[4]": "16",
    "forcedisplay[5]": "75",
    "forcedisplay[6]": "74",
    sort: "1",
    order: "ASC",
    get_hateoas: "0",
    range: "0-39999",
  };

  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "",
    create_date = "",
    consumption = "";

  if (filter != "") {
    params = {
      "criteria[1][field]": "1",
      "criteria[1][searchtype]": "contains",
      "criteria[1][value]": `${filter}%20>`,
      "forcedisplay[0]": "2",
      "forcedisplay[1]": "14",
      "forcedisplay[2]": "1",
      "forcedisplay[3]": "13",
      "forcedisplay[4]": "16",
      "forcedisplay[5]": "75",
      "forcedisplay[6]": "74",
      order: "ASC",
      get_hateoas: "0",
      range: "0-39999",
    };
  }

  return api
    .get(url, { params })
    .then(handleResponse)
    .then(data => {
      var total = data.totalcount;
      var list = [];

      if (total > 0) {
        for (j = 0; j < data.data.length; j++) {
          list.push({
            id: data.data[j][2],
            name: data.data[j][14],
            completename: data.data[j][1],
            parent: data.data[j][13],
            comment: data.data[j][16],
            request: data.data[j][75],
            incident: data.data[j][74],
          });
        }
      }

      return {
        list: list,
        total: total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchEquipmentTypes(token, type) {
  var listEquipments = [];
  var totalEquipments = 0;
  let url = `${actiDomain}search/${type}type`;
  let params = {
    "forcedisplay[0]": "2",
    "forcedisplay[1]": "16",
    "forcedisplay[2]": "1",
    sort: "1",
    order: "ASC",
    get_hateoas: "0",
    range: "0-39999",
  };
  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "",
    create_date = "",
    consumption = "";

  if (type == "software") {
    url = `${actiDomain}search/${type}category`;
    params = {
      "forcedisplay[0]": "2",
      "forcedisplay[1]": "16",
      "forcedisplay[2]": "1",
      sort: "1",
      order: "ASC",
      get_hateoas: "0",
      range: "0-39999",
    };
  }

  return api
    .get(url, { params })
    .then(handleResponse)
    .then(data => {
      // console.log(data);

      var total = data.totalcount;
      var list = [];

      if (total > 0) {
        for (j = 0; j < data.data.length; j++) {
          list.push({
            id: data.data[j][2],
            name: data.data[j][1],
            comment: data.data[j][16],
          });
        }
      }

      return {
        list: list,
        total: total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchRequestType(token, filter) {
  var listEquipments = [];
  var totalEquipments = 0;
  const url = `${actiDomain}search/requesttype`;
  let params = {
    "forcedisplay[0]": "2",
    order: "ASC",
    get_hateoas: "0",
    range: "0-39999",
  };
  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "",
    create_date = "",
    consumption = "";

  // console.log("TOKEN: "+token)

  if (filter != "") {
    params = {
      "criteria[1][field]": "1",
      "criteria[1][searchtype]": "contains",
      "criteria[1][value]": `${filter}%20-`,
      "forcedisplay[0]": "2",
      "forcedisplay[1]": "14",
      order: "ASC",
      get_hateoas: "0",
      range: "0-39999",
    };
  }
  return api
    .get(url, { params })
    .then(handleResponse)
    .then(data => {
      var total = data.totalcount;
      var list = [];

      if (total > 0) {
        for (j = 0; j < data.data.length; j++) {
          list.push({
            id: data.data[j][2],
            name: data.data[j][1],
          });
        }
      }

      return {
        list: list,
        total: total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchGeneric(token, item, id, subitem, filter, range) {
  var listEquipments = [];
  var totalEquipments = 0;
  var url = `${actiDomain}${item}/${id}/${subitem}/?${filter}&range=0-${range}`;

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      var total = data.length;
      var list = [];

      if (total > 0) {
        for (var j = 0; j < data.length; j++) {
          list.push(data[j]);
        }
      }

      return {
        list: list,
        total: total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchGenericWithFilter(
  token,
  item,
  criteria,
  forcedisplay,
  range_end,
  range_init = "0",
  options = "",
) {
  var swapCriteria = "";
  if (criteria != null) {
    for (var j = 0; j < criteria.length; j++) {
      if (criteria[j] != null) {
        swapCriteria =
          swapCriteria +
          "criteria[" +
          j.toString() +
          "][link]=" +
          criteria[j][0];
        swapCriteria =
          swapCriteria +
          "&criteria[" +
          j.toString() +
          "][field]=" +
          criteria[j][1];
        swapCriteria =
          swapCriteria +
          "&criteria[" +
          j.toString() +
          "][searchtype]=" +
          criteria[j][2];
        swapCriteria =
          swapCriteria +
          "&criteria[" +
          j.toString() +
          "][value]=" +
          criteria[j][3];
        swapCriteria = swapCriteria + "&";
      }
    }
  }

  var swapForceDisplay = "";
  if (forcedisplay != null) {
    for (var j = 0; j < forcedisplay.length; j++) {
      swapForceDisplay =
        swapForceDisplay +
        "forcedisplay[" +
        j.toString() +
        "]=" +
        forcedisplay[j];
      swapForceDisplay = swapForceDisplay + "&";
    }
  }

  var url = `${actiDomain}search/${item}?${swapCriteria}${swapForceDisplay}&range=${range_init}-${range_end}&${options}`;

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      var total = data.count;
      var totalTickets = data.totalcount;
      var list = [];

      if (total > 0) {
        for (var j = 0; j < data.data.length; j++) {
          list.push(data.data[j]);
        }
      }

      return {
        list,
        total,
        totalTickets,
      };
    });
}

function searchConsumableItemQuantity(token) {
  var glpiConsumableItem = [];
  var totalConsumableItem = 0;
  var j = 0;

  return api
    .get(
      `${actiDomain}search/consumableitem?forcedisplay[0]=2&forcedisplay[1]=19&forcedisplay[2]=1&forcedisplay[3]=80&range=0-1`,
    )
    .then(handleResponse)
    .then(data => {
      totalConsumableItem = (data && data.totalcount) || 0;

      if (totalConsumableItem > 0) {
        for (j = 0; j < data.data.length; j++) {
          glpiConsumableItem.push({
            id: data.data[j][2],
            name: data.data[j][1],
            quantity: data.data[j][19],
            selected: 0,
          });
        }
      }

      return {
        glpiConsumableItem,
        totalConsumableItem,
      };
    });
}

function getConsumables(token) {
  var glpiConsumables = [];
  var totalConsumables = 0;
  var j = 0;

  return api
    .get(
      `${actiDomain}consumable?searchText[itemtype]=null&get_hateoas=0&is_deleted=0&range=0-2000`,
    )
    .then(handleResponse)
    .then(data => {
      totalConsumables = data.totalcount;

      if (totalConsumables > 0) {
        for (j = 0; j < data.data.length; j++) {
          glpiConsumables.push({
            id: data.data[j]["id"],
            type: data.data[j]["consumableitems_id"],
          });
        }
      }

      return {
        glpiConsumables: glpiConsumables,
        totalConsumables: totalConsumables,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchTicketsAproved(token, status, page, date_begin, date_end) {
  var glpiLastTickets = [];
  var totalTickets = 0;
  var j = 0;

  var url = `${actiDomain}search/ticket?criteria[1][field]=52&criteria[1][searchtype]=equals&criteria[1][value]=3&criteria[2][field]=12&criteria[2][searchtype]=contains&criteria[2][value]=${status}&forcedisplay[0]=2&forcedisplay[1]=12&forcedisplay[2]=1&forcedisplay[3]=10&forcedisplay[4]=3&forcedisplay[5]=7&forcedisplay[6]=15&forcedisplay[7]=17&range=${(page -
    1) *
    10}-${page * 10 - 1}&sort=2&order=DESC`;

  if (date_begin != null && date_end != null) {
    url = `${actiDomain}search/ticket?criteria[0][field]=12&criteria[0][searchtype]=equals&criteria[0][value]=${status}&criteria[1][link]=AND&criteria[1][field]=15&criteria[1][searchtype]=morethan&criteria[1][value]=${date_begin}&criteria[2][link]=AND&criteria[2][field]=15&criteria[2][searchtype]=lessthan&criteria[2][value]=${date_end}&forcedisplay[0]=2&forcedisplay[1]=1&forcedisplay[2]=80&forcedisplay[3]=7&forcedisplay[4]=15&forcedisplay[6]=16&forcedisplay[7]=18&forcedisplay[8]=17&forcedisplay[9]=155&forcedisplay[10]=60&forcedisplay[11]=3&forcedisplay[12]=4&forcedisplay[13]=9&forcedisplay[14]=10&forcedisplay[15]=5&forcedisplay[16]=95&forcedisplay[17]=21&forcedisplay[18]=12&forcedisplay[19]=24&forcedisplay[20]=25&forcedisplay[21]=96&forcedisplay[22]=48&forcedisplay[23]=42&forcedisplay[24]=43&forcedisplay[25]=44&forcedisplay[26]=13&forcedisplay[27]=131&range=${(page -
      1) *
      10}-${page * 10 - 1}&sort=2&order=DESC&get_hateoas=0`;
  }

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      totalTickets = data.totalcount;

      if (totalTickets > 0) {
        for (j = 0; j < data.data.length; j++) {
          glpiLastTickets.push({
            id: data.data[j][2],
            status: data.data[j][12],
            title: data.data[j][1],
            modality: data.data[j][10],
            priority: data.data[j][3],
            category: data.data[j][7],
            date: data.data[j][15],
          });
        }
      }

      return {
        glpiLastTickets,
        totalTickets,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchTicketsWaiting(token, status, page, date_begin, date_end) {
  var glpiLastTickets = [];
  var totalTickets = 0;
  var j = 0;

  var url = `${actiDomain}search/ticket?criteria[1][field]=52&criteria[1][searchtype]=equals&criteria[1][value]=1&criteria[2][field]=12&criteria[2][searchtype]=contains&criteria[2][value]=${status}&forcedisplay[0]=2&forcedisplay[1]=12&forcedisplay[2]=1&forcedisplay[3]=10&forcedisplay[4]=3&forcedisplay[5]=7&forcedisplay[6]=15&forcedisplay[7]=17&range=${(page -
    1) *
    10}-${page * 10 - 1}&sort=2&order=DESC`;

  if (date_begin != null && date_end != null) {
    url = `${actiDomain}search/ticket?criteria[0][field]=12&criteria[0][searchtype]=equals&criteria[0][value]=${status}&criteria[1][link]=AND&criteria[1][field]=15&criteria[1][searchtype]=morethan&criteria[1][value]=${date_begin}&criteria[2][link]=AND&criteria[2][field]=15&criteria[2][searchtype]=lessthan&criteria[2][value]=${date_end}&forcedisplay[0]=2&forcedisplay[1]=1&forcedisplay[2]=80&forcedisplay[3]=7&forcedisplay[4]=15&forcedisplay[6]=16&forcedisplay[7]=18&forcedisplay[8]=17&forcedisplay[9]=155&forcedisplay[10]=60&forcedisplay[11]=3&forcedisplay[12]=4&forcedisplay[13]=9&forcedisplay[14]=10&forcedisplay[15]=5&forcedisplay[16]=95&forcedisplay[17]=21&forcedisplay[18]=12&forcedisplay[19]=24&forcedisplay[20]=25&forcedisplay[21]=96&forcedisplay[22]=48&forcedisplay[23]=42&forcedisplay[24]=43&forcedisplay[25]=44&forcedisplay[26]=13&forcedisplay[27]=131&range=${(page -
      1) *
      10}-${page * 10 - 1}&sort=2&order=DESC&get_hateoas=0`;
  }

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      totalTickets = data.totalcount;

      if (totalTickets > 0) {
        for (j = 0; j < data.data.length; j++) {
          glpiLastTickets.push({
            id: data.data[j][2],
            status: data.data[j][12],
            title: data.data[j][1],
            modality: data.data[j][10],
            priority: data.data[j][3],
            category: data.data[j][7],
            date: data.data[j][15],
          });
        }
      }

      return {
        glpiLastTickets,
        totalTickets,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchTicketsByStatus(
  token,
  status,
  page,
  date_begin,
  date_end,
  extra = null,
) {
  var glpiLastTickets = [];
  var totalTickets = 0;
  var j = 0;

  var url = `${actiDomain}search/ticket?criteria[2][field]=12&criteria[2][searchtype]=equals&criteria[2][value]=${status}&forcedisplay[0]=2&forcedisplay[1]=12&forcedisplay[2]=1&forcedisplay[3]=10&forcedisplay[4]=3&forcedisplay[5]=7&forcedisplay[6]=15&forcedisplay[7]=17&range=${(page -
    1) *
    10}-${page * 10 - 1}&sort=2&order=DESC`;
  if (date_begin != null && date_end != null) {
    url = `${actiDomain}search/ticket?criteria[0][field]=12&criteria[0][searchtype]=equals&criteria[0][value]=${status}&criteria[1][link]=AND&criteria[1][field]=15&criteria[1][searchtype]=morethan&criteria[1][value]=${date_begin}&criteria[2][link]=AND&criteria[2][field]=15&criteria[2][searchtype]=lessthan&criteria[2][value]=${date_end}&forcedisplay[0]=2&forcedisplay[1]=1&forcedisplay[2]=80&forcedisplay[3]=7&forcedisplay[4]=15&forcedisplay[6]=16&forcedisplay[7]=18&forcedisplay[8]=17&forcedisplay[9]=155&forcedisplay[10]=60&forcedisplay[11]=3&forcedisplay[12]=4&forcedisplay[13]=9&forcedisplay[14]=10&forcedisplay[15]=5&forcedisplay[16]=95&forcedisplay[17]=21&forcedisplay[18]=12&forcedisplay[19]=24&forcedisplay[20]=25&forcedisplay[21]=96&forcedisplay[22]=48&forcedisplay[23]=42&forcedisplay[24]=43&forcedisplay[25]=44&forcedisplay[26]=13&forcedisplay[27]=131&range=${(page -
      1) *
      10}-${page * 10 - 1}&sort=2&order=DESC&get_hateoas=0`;
  }

  if (extra != null) {
    url += `&${extra}`;
  }

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      totalTickets = data.totalcount;

      if (totalTickets > 0) {
        for (j = 0; j < data.data.length; j++) {
          glpiLastTickets.push({
            id: data.data[j][2],
            status: data.data[j][12],
            title: data.data[j][1],
            modality: data.data[j][10],
            priority: data.data[j][3],
            category: data.data[j][7],
            date: data.data[j][15],
          });
        }
      }

      return {
        glpiLastTickets,
        totalTickets,
      };
    });
}

// Tickets from last year , but with only 1000 being presented
function searchTicketsInfo(
  token,
  status,
  page,
  date_begin,
  date_end,
  extra = null,
) {
  var list = [];
  var total = 0;
  var j = 0;

  var url = `${actiDomain}search/ticket?criteria[2][field]=12&criteria[2][searchtype]=equals&criteria[2][value]=${status}&ticket?forcedisplay[0]=2&forcedisplay[1]=1&forcedisplay[2]=80&forcedisplay[3]=7&forcedisplay[4]=15&forcedisplay[6]=16&forcedisplay[7]=18&forcedisplay[8]=17&forcedisplay[9]=155&forcedisplay[10]=60&forcedisplay[11]=3&forcedisplay[12]=4&forcedisplay[13]=9&forcedisplay[14]=10&forcedisplay[15]=5&forcedisplay[16]=95&forcedisplay[17]=21&forcedisplay[18]=12&forcedisplay[19]=24&forcedisplay[20]=25&forcedisplay[21]=96&forcedisplay[22]=48&forcedisplay[23]=42&forcedisplay[24]=43&forcedisplay[25]=44&forcedisplay[26]=13&forcedisplay[27]=131&range=${(page -
    1) *
    1000}-${page * 1000 - 1}&sort=2&order=DESC&get_hateoas=0`;

  if (date_begin != null && date_end != null) {
    url = `${actiDomain}search/ticket?criteria[0][field]=12&criteria[0][searchtype]=equals&criteria[0][value]=${status}&criteria[1][link]=AND&criteria[1][field]=15&criteria[1][searchtype]=morethan&criteria[1][value]=${date_begin}&criteria[2][link]=AND&criteria[2][field]=15&criteria[2][searchtype]=lessthan&criteria[2][value]=${date_end}&forcedisplay[0]=2&forcedisplay[1]=1&forcedisplay[2]=80&forcedisplay[3]=7&forcedisplay[4]=15&forcedisplay[6]=16&forcedisplay[7]=18&forcedisplay[8]=17&forcedisplay[9]=155&forcedisplay[10]=60&forcedisplay[11]=3&forcedisplay[12]=4&forcedisplay[13]=9&forcedisplay[14]=10&forcedisplay[15]=5&forcedisplay[16]=95&forcedisplay[17]=21&forcedisplay[18]=12&forcedisplay[19]=24&forcedisplay[20]=25&forcedisplay[21]=96&forcedisplay[22]=48&forcedisplay[23]=42&forcedisplay[24]=43&forcedisplay[25]=44&forcedisplay[26]=13&forcedisplay[27]=131&range=${(page -
      1) *
      1000}-${page * 1000 - 1}&sort=2&order=DESC&get_hateoas=0`;
  }

  if (extra != null) {
    url += `&${extra}`;
  }

  return api
    .get(url)
    .then(handleResponse)
    .then(data => {
      total = data.totalcount;

      if (total > 0) {
        for (j = 0; j < data.data.length; j++) {
          list.push({
            id: data.data[j][2],
            title: data.data[j][1],
            entity: data.data[j][80],
            category: data.data[j][7],
            date_create: data.data[j][60],
            date_sla_begin: data.data[j][155],
            date: data.data[j][15],
            date_sla_solution: data.data[j][18],
            date_solution: data.data[j][17],
            date_close: data.data[j][16],
            priority: data.data[j][3],
            user_req: data.data[j][4],
            ori_req: data.data[j][9],
            modality: data.data[j][10],
            user_tech: data.data[j][5],
            act_tech: data.data[j][95],
            // description:data.data[j][21],
            status: data.data[j][12],
            // solution: data.data[j][24],
            // feedback: data.data[j][25],
            hours: data.data[j][96],
            cost_time: data.data[j][42],
            cost_fixed: data.data[j][43],
            cost_material: data.data[j][44],
            totalcost: data.data[j][48],
            equipment: data.data[j][13],
            equipment_type: data.data[j][131],
            // pendind_cat: data.data[j][76672],
          });
        }
      }

      return {
        list,
        total,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchEquipmentsByStatus(token, page) {
  var listEquipments = [];
  var totalEquipments = 0;
  var j = 0;

  return api
    .get(
      `${actiDomain}search/AllAssets?forcedisplay[0]=1&forcedisplay[1]=6&forcedisplay[2]=23&forcedisplay[3]=5&forcedisplay[4]=3&range=${(page -
        1) *
        10}-${page * 10 - 1}&sort=1&order=DESC`,
    )
    .then(handleResponse)
    .then(data => {
      var totalEquipments = data.totalcount;

      if (totalEquipments > 0) {
        for (j = 0; j < data.data.length; j++) {
          listEquipments.push({
            id: data.data[j]["id"],
            tag: data.data[j][6],
            type: data.data[j][1],
            fab: data.data[j][23],
            sn: data.data[j][5],
            location: data.data[j][3],
            site: data.data[j][80],
          });
        }
      }

      return {
        listEquipments,
        totalEquipments,
      };
    });
}

// Tickets from last year , but with only 10 being presented
async function searchEquipmentsByType(token, type, description, page, pageSize = 10) {
  const params = {
    "forcedisplay": [
      "1",
      "6",
      "23",
      "5",
      "3",
      "40",
      "4",
      "60",
      "2"
    ],
    "range": `${(page - 1) * pageSize}-${page * pageSize - 1}`,
    "sort": "1",
    "order": "ASC"
  };

  const { data } = await api.get(`${actiDomain}search/${type}`, { params });
  
  let listEquipments = [];

  if (data.totalcount > 0) {
    listEquipments = data.data.map(value => ({
      id: value[2],
      tag: value[6],
      name: value[1],
      fab: value[23],
      sn: value[5],
      location: value[3],
      model: value[40],
      type: value[4],
      ticket_ids: value[60],
      site: value[80],
    }));
  }

  return {
    listEquipments,
    totalEquipments: data.totalcount,
    type,
    page,
    active: data.totalcount > 0,
    description,
  };
}

function searchEquipmentsByTypeSimple(token, type) {
  var listEquipments = [];
  var totalEquipments = 0;
  var j = 0;

  // console.log("TOKEN: "+token)

  if (type != "software") {
    return api
      .get(
        `${actiDomain}search/${type}?forcedisplay[0]=1&forcedisplay[1]=6&forcedisplay[2]=23&forcedisplay[3]=5&forcedisplay[4]=3&forcedisplay[5]=40&forcedisplay[6]=4&forcedisplay[7]=60&forcedisplay[8]=2&range=0-990&sort=1&order=DESC`,
      )
      .then(handleResponse)
      .then(data => {
        var totalEquipments = data.totalcount;
        var active = true;

        if (totalEquipments > 0) {
          for (j = 0; j < data.data.length; j++) {
            listEquipments.push({
              id: data.data[j][2],
              tag: data.data[j][6],
              name: data.data[j][1],
              fab: data.data[j][23],
              sn: data.data[j][5],
              location: data.data[j][3],
              model: data.data[j][40],
              type: data.data[j][4],
              ticket_ids: data.data[j][60],
              site: data.data[j][80],
            });
          }
        } else {
          active = false;
        }

        return {
          list: listEquipments,
          total: totalEquipments,
        };
      });
  } else {
    return api
      .get(
        `${actiDomain}search/${type}?forcedisplay[0]=1&forcedisplay[1]=6&forcedisplay[2]=23&forcedisplay[3]=5&forcedisplay[4]=3&forcedisplay[5]=40&forcedisplay[6]=62&forcedisplay[7]=60&forcedisplay[8]=2&range=0-990&sort=1&order=DESC`,
      )
      .then(handleResponse)
      .then(data => {
        var totalEquipments = data.totalcount;
        var active = true;

        if (totalEquipments > 0) {
          for (j = 0; j < data.data.length; j++) {
            listEquipments.push({
              id: data.data[j][2],
              tag: data.data[j][6],
              name: data.data[j][1],
              fab: data.data[j][23],
              sn: data.data[j][5],
              location: data.data[j][3],
              model: data.data[j][40],
              type: data.data[j][62],
              ticket_ids: data.data[j][60],
              site: data.data[j][80],
            });
          }
        } else {
          active = false;
        }

        return {
          list: listEquipments,
          total: totalEquipments,
        };
      });
  }
}

// Tickets from last year , but with only 10 being presented
function searchConsumableItemType(token) {
  var listEquipments = [];
  var totalEquipments = 0;
  var j = 0;

  return api
    .get(
      `${actiDomain}search/consumableitemtype?forcedisplay[0]=1&forcedisplay[1]=2&sort=1&order=DESC`,
    )
    .then(handleResponse)
    .then(data => {
      var totalTypes = data.totalcount;
      var types = [];

      if (totalTypes > 0) {
        for (j = 0; j < data.data.length; j++) {
          types.push(data.data[j][1]);
        }
      }

      return {
        totalTypes,
        types,
      };
    });
}

// Tickets from last year , but with only 10 being presented
function searchConsumableItemByType(token, type, page) {
  var listEquipments = [];
  var totalEquipments = 0;
  var j = 0,
    splited = "",
    value = null,
    leadtime = null,
    auto = 0,
    unity = "PÇ",
    supplier = "",
    create_date = "",
    consumption = "";

  return api
    .get(
      `${actiDomain}search/consumableitem?criteria[0][field]=4&criteria[0][searchtype]=contains&criteria[0][value]=${type}&forcedisplay[0]=1&forcedisplay[1]=2&forcedisplay[2]=34&forcedisplay[3]=4&forcedisplay[4]=23&forcedisplay[5]=9&forcedisplay[6]=17&forcedisplay[7]=19&forcedisplay[8]=3&forcedisplay[9]=8&forcedisplay[10]=16&range=${(page -
        1) *
        10}-${page * 10 - 1}&sort=1&order=ASC`,
    )
    .then(handleResponse)
    .then(data => {
      var totalConsumables = data.totalcount;
      var listConsumables = [];

      if (totalConsumables > 0) {
        for (j = 0; j < data.data.length; j++) {
          splited = data.data[j][16].split("|");
          if (splited.length >= 7) {
            value = splited[0];
            leadtime = splited[1];
            auto = splited[2];
            unity = splited[3];
            supplier = splited[4];
            create_date = splited[5];
            consumption = splited[6];
          } else {
            if (splited.length >= 5) {
              value = splited[0];
              leadtime = splited[1];
              auto = splited[2];
              unity = splited[3];
              supplier = splited[4];
            }
          }

          listConsumables.push({
            id: data.data[j][2],
            name: data.data[j][1],
            ref: data.data[j][34],
            type: data.data[j][4],
            fab: data.data[j][23],
            used: data.data[j][17],
            // new:"10",
            new: data.data[j][19],
            total: parseInt(data.data[j][17]) + parseInt(data.data[j][19]),
            location: data.data[j][3],
            // min:"8",
            min: data.data[j][8],
            comment: data.data[j][16],
            value: value,
            leadtime: leadtime,
            auto: auto,
            unity: unity,
            supplier: supplier,
            create_date: create_date,
            consumption: consumption,
          });
        }
      }

      return {
        list: listConsumables,
        total: totalConsumables,
        type: type,
        page: page,
      };
    });
}

function getAll() {
  return api.get(`${actiDomain}users`).then(handleResponse);
}

function states(token) {
  var states = [];
  var swap = [];

  return api
    .get(
      `${actiDomain}search/entity?forcedisplay[0]=12&forcedisplay[1]=4&forcedisplay[2]=8&range=0-990`,
    )
    .then(handleResponse)
    .then(data => {
      var i;
      for (i = 0; i < data.data.length; i++) {
        if (
          data.data[i][4] != null &&
          data.data[i][4] &&
          data.data[i][8] != null &&
          data.data[i][8]
        ) {
          swap.push(data.data[i][12]);
        }
      }
      //Get distict states
      states = [...new Set(swap)];
      return states;
    });
}

//Zabbix requests

//Login
function loginZabbix(token) {
  //Variable
  var entities = [];

  //Entities request
  return api
    .get(
      `${actiDomain}search/entity?forcedisplay[0]=2&forcedisplay[1]=4&forcedisplay[2]=12&forcedisplay[3]=8&forcedisplay[4]=14&range=0-990`,
    )
    .then(handleResponse)
    .then(function handleData(data) {
      var entities = data.data;
      var tokenData = [];
      var i;
      //For each entity
      for (i = 0; i < entities.length; i++) {
        //Filter the ones that have Online
        if (
          entities[i][4] != null &&
          entities[i][4] &&
          entities[i][8] != null &&
          entities[i][8]
        ) {
          fetch(
            zabbixDomain,
            apiRequests.reqLoginZabbix(entities[i][8], entities[i][8]),
          )
            .then(response => {
              if (response.ok) return response.json();
              throw new Error(response.statusText);
            })
            //In case of sucess
            .then(function handleData(data) {
              //Get the Entity info from request scope
              const body = JSON.parse(requestOptions.body);
              //Append the token data
              tokenData.push({
                site: body.params.user,
                token: data.result,
              });
            })
            .catch(function handleError(error) {});
        }
      }

      return tokenData;
    })
    .catch(function handleError(error) {});
}

//Problems
function problemsZabbix(token) {
  //Variable
  var entities = [];

  //Entities request
  return api
    .get(
      `${actiDomain}search/entity?forcedisplay[0]=2&forcedisplay[1]=4&forcedisplay[2]=12&forcedisplay[3]=8&forcedisplay[4]=14&range=0-990`,
    )
    .then(handleResponse)
    .then(function handleData(data) {
      var entities = data.data;
      var tokenData = [];
      var i;
      //For each entity
      for (i = 0; i < entities.length; i++) {
        //Filter the ones that have Online
        if (
          entities[i][4] != null &&
          entities[i][4] &&
          entities[i][8] != null &&
          entities[i][8]
        ) {
          //Zabbix Login Scope
          const requestOptions = {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
              jsonrpc: "2.0",
              method: "user.login",
              params: {
                user: entities[i][8],
                password: entities[i][8],
              },
              id: 1,
              auth: null,
            }),
          };
          fetch(zabbixDomain, requestOptions)
            .then(response => {
              if (response.ok) return response.json();
              throw new Error(response.statusText);
            })
            //In case of sucess
            .then(function handleData(data) {
              //Get the Entity info from request scope
              const body = JSON.parse(requestOptions.body);
              //Append the token data
              tokenData.push({
                site: body.params.user,
                token: data.result,
              });
            })
            .catch(function handleError(error) {});
        }
      }
      var problems = [];
      // console.log(tokenData);
      //For each zabbix token
      for (i = 0; i <= tokenData.length; i++) {
        // console.log(tokenData);
        //Zabbix Login Scope
        const requestOptions2 = {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            jsonrpc: "2.0",
            method: "problem.get",
            params: {
              output: "extend",
              selectAcknowledges: "extend",
              selectTags: "extend",
              selectSuppressionData: "extend",
              recent: "true",
              sortfield: ["eventid"],
              sortorder: "DESC",
            },
            auth: tokenData[i].token,
            id: 1,
          }),
        };
        // console.log(requestOptions2);
        fetch(zabbixDomain, requestOptions2)
          .then(response => {
            if (response.ok) return response.json();
            throw new Error(response.statusText);
          })
          //In case of sucess
          .then(function handleData(data) {
            // console.log(data);
            // //Append the token data
            // problems.push({
            //   "site": body.params.user,
            //   "token": data.result
            // });
          })
          .catch(function handleError(error) {});
      }
      return tokenData;
    })
    .catch(function handleError(error) {});
}

function handleResponse(response) {
  return response.data;
}

async function AsingZabbixInfoBySite(zabbixSite) {
  // console.log(zabbixSite)

  var entities = [];
  var zabbixSites = [];
  var zabbixAlarms = [];
  var zabbixTriggers = [];
  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var request = [],
    request2 = [],
    request3 = [],
    request4 = [];
  var i = 0,
    j = 0,
    k = 0,
    l = 0,
    m = 0;
  var count = 0,
    correlation = [];
  zabbixSites.push(zabbixSite);
  // console.log("Result!");
  // console.log(zabbixSites)

  //Get Hosts
  request = [];
  correlation = [];
  count = 0;
  var hosts = [];
  for (i = 0; i < zabbixSites.length; i++) {
    request.push(
      apiRequests.reqHostsZabbix(
        zabbixSites[i].token,
        zabbixSites[i].entity,
        i,
      ),
    );
  }
  try {
    const response4 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response4.data.length; i++) {
      hosts = [];
      for (j = 0; j < response4.data[i].result.length; j++) {
        hosts.push({
          name: response4.data[i].result[j].host,
          id: response4.data[i].result[j].hostid,
          applications: [],
          alarmPriority: "green",
          count: j,
        });
      }
      zabbixSites[i].hosts = hosts;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Applications
  request = [];
  correlation = [];
  count = 0;
  var applications = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      request.push(
        apiRequests.reqApplicationsZabbix(
          zabbixSites[i].token,
          zabbixSites[i].hosts[j].id,
          count,
        ),
      );
      count = count + 1;
      correlation.push({ site: i, host: j });
    }
  }
  try {
    const response5 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response5.data.length; i++) {
      applications = [];
      for (j = 0; j < response5.data[i].result.length; j++) {
        applications.push({
          name: response5.data[i].result[j].name,
          id: response5.data[i].result[j].applicationid,
          itens: [],
          alarmPriority: "green",
          count: j,
        });
      }
      zabbixSites[correlation[i].site].hosts[
        correlation[i].host
      ].applications = applications;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Itens
  request = [];
  correlation = [];
  count = 0;
  var itens = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        request.push(
          apiRequests.reqItensZabbix(
            zabbixSites[i].token,
            zabbixSites[i].hosts[j].id,
            zabbixSites[i].hosts[j].applications[k].id,
            count,
          ),
        );
        count = count + 1;
        correlation.push({ site: i, host: j, application: k });
      }
    }
  }
  try {
    const response6 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response6.data.length; i++) {
      itens = [];
      for (j = 0; j < response6.data[i].result.length; j++) {
        if (response6.data[i].result[j].units != "hid") {
          if (response6.data[i].result[j].units == "bin") {
            itens.push({
              name: response6.data[i].result[j].name,
              id: response6.data[i].result[j].itemid,
              key: response6.data[i].result[j].key_,
              units: response6.data[i].result[j].units,
              lastvalue: "OK",
              priority: "0",
            });
          } else {
            if (response6.data[i].result[j].units == "enum") {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: "OK",
                priority: "0",
              });
            } else {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: response6.data[i].result[j].lastvalue,
                priority: "0",
              });
            }
          }
        }
      }
      zabbixSites[correlation[i].site].hosts[correlation[i].host].applications[
        correlation[i].application
      ].itens = itens;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Triggers
  request = [];
  correlation = [];
  count = 0;
  var triggers = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        for (
          l = 0;
          l < zabbixSites[i].hosts[j].applications[k].itens.length;
          l++
        ) {
          if (zabbixSites[i].hosts[j].applications[k].itens[l].units != "hid") {
            request.push(
              apiRequests.reqTriggerZabbix(
                zabbixSites[i].token,
                zabbixSites[i].hosts[j].id,
                zabbixSites[i].hosts[j].applications[k].id,
                zabbixSites[i].hosts[j].applications[k].itens[l].id,
                count,
              ),
            );
            count = count + 1;
            correlation.push({ site: i, host: j, application: k, item: l });
          }
        }
      }
    }
  }
  try {
    const response7 = await axios.post(zabbixDomain, request);
    // console.log(response7);
    zabbixTriggers = JSON.parse(localStorage.getItem("triggers"));
    for (i = 0; i < response7.data.length; i++) {
      itens = [];
      for (j = 0; j < response7.data[i].result.length; j++) {
        if (
          response7.data[i].result[j].value == "1" &&
          response7.data[i].result[j].status == "0"
        ) {
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "enum"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = response7.data[i].result[j].description;
          }
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "bin"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = "ALARME";
          }
          zabbixSites[correlation[i].site].hosts[
            correlation[i].host
          ].applications[correlation[i].application].itens[
            correlation[i].item
          ].priority = response7.data[i].result[j].priority;
        }
        zabbixTriggers[response7.data[i].result[j].triggerid] = {
          site: zabbixSites[correlation[i].site].site,
          host:
            zabbixSites[correlation[i].site].hosts[correlation[i].host].name,
          application:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].name,
          item:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].name,
          priority: response7.data[i].result[j].priority,
          description: response7.data[i].result[j].description,
        };
      }
    }
  } catch (e) {
    errors2.push(e);
  }
  localStorage.setItem("triggers", JSON.stringify(zabbixTriggers));

  var swapSites = JSON.parse(localStorage.getItem("sites"));
  // console.log('SITES:')
  // console.log(swapSites)
  // console.log('SITE ID:')
  swapSites[zabbixSite.id] = zabbixSites[0];
  localStorage.setItem("sites", JSON.stringify(swapSites));

  var apiData = {
    sites: swapSites,
    triggers: zabbixTriggers,
    id: zabbixSite.id,
  };
  return apiData;

  // localStorage.setItem('triggers', JSON.stringify(zabbixTriggers));
  //
  //
  // console.log(zabbixSites)
  // console.log(zabbixTriggers)
  //
  // var apiData={sites:zabbixSites,
  //             triggers:zabbixTriggers};
  //
  // user = JSON.parse(localStorage.getItem('user'));
  // user = JSON.parse(localStorage.getItem('user'));
  // localStorage.setItem('sites', JSON.stringify(zabbixSites));
  // localStorage.setItem('triggers', JSON.stringify(zabbixTriggers));
  // // console.log(zabbixTriggers)
  // return apiData;
}

// Update Token
async function AsingUpdateZabbixToken(zabbixSites) {
  var entities = [];
  var zabbixAlarms = [];
  var zabbixTriggers = [];
  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var request = [],
    request2 = [],
    request3 = [],
    request4 = [];
  var i = 0,
    j = 0,
    k = 0,
    l = 0,
    m = 0;
  var count = 0,
    correlation = [];

  //Get Zabbix Tokens
  for (i = 0; i < zabbixSites.length; i++) {
    request.push(
      apiRequests.reqLoginZabbix(
        zabbixSites[i].entity,
        zabbixSites[i].entity,
        i,
      ),
    );
  }
  try {
    const response2 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response2.data.length; i++) {
      zabbixSites[i].token = response2.data[i].result;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Hosts
  request = [];
  correlation = [];
  count = 0;
  var hosts = [];
  for (i = 0; i < zabbixSites.length; i++) {
    request.push(
      apiRequests.reqHostsZabbix(
        zabbixSites[i].token,
        zabbixSites[i].entity,
        i,
      ),
    );
  }
  try {
    const response4 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response4.data.length; i++) {
      hosts = [];
      for (j = 0; j < response4.data[i].result.length; j++) {
        hosts.push({
          name: response4.data[i].result[j].host,
          id: response4.data[i].result[j].hostid,
          applications: [],
          alarmPriority: "green",
          count: j,
        });
      }
      zabbixSites[i].hosts = hosts;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Applications
  request = [];
  correlation = [];
  count = 0;
  var applications = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      request.push(
        apiRequests.reqApplicationsZabbix(
          zabbixSites[i].token,
          zabbixSites[i].hosts[j].id,
          count,
        ),
      );
      count = count + 1;
      correlation.push({ site: i, host: j });
    }
  }
  try {
    const response5 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response5.data.length; i++) {
      applications = [];
      for (j = 0; j < response5.data[i].result.length; j++) {
        applications.push({
          name: response5.data[i].result[j].name,
          id: response5.data[i].result[j].applicationid,
          itens: [],
          alarmPriority: "green",
          count: j,
        });
      }
      zabbixSites[correlation[i].site].hosts[
        correlation[i].host
      ].applications = applications;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Itens
  request = [];
  correlation = [];
  count = 0;
  var itens = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        request.push(
          apiRequests.reqItensZabbix(
            zabbixSites[i].token,
            zabbixSites[i].hosts[j].id,
            zabbixSites[i].hosts[j].applications[k].id,
            count,
          ),
        );
        count = count + 1;
        correlation.push({ site: i, host: j, application: k });
      }
    }
  }
  try {
    const response6 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response6.data.length; i++) {
      itens = [];
      for (j = 0; j < response6.data[i].result.length; j++) {
        if (response6.data[i].result[j].units != "hid") {
          if (response6.data[i].result[j].units == "bin") {
            itens.push({
              name: response6.data[i].result[j].name,
              id: response6.data[i].result[j].itemid,
              key: response6.data[i].result[j].key_,
              units: response6.data[i].result[j].units,
              lastvalue: "OK",
              priority: "0",
            });
          } else {
            if (response6.data[i].result[j].units == "enum") {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: "OK",
                priority: "0",
              });
            } else {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: response6.data[i].result[j].lastvalue,
                priority: "0",
              });
            }
          }
        }
      }
      zabbixSites[correlation[i].site].hosts[correlation[i].host].applications[
        correlation[i].application
      ].itens = itens;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Triggers
  request = [];
  correlation = [];
  count = 0;
  var triggers = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        for (
          l = 0;
          l < zabbixSites[i].hosts[j].applications[k].itens.length;
          l++
        ) {
          if (zabbixSites[i].hosts[j].applications[k].itens[l].units != "hid") {
            request.push(
              apiRequests.reqTriggerZabbix(
                zabbixSites[i].token,
                zabbixSites[i].hosts[j].id,
                zabbixSites[i].hosts[j].applications[k].id,
                zabbixSites[i].hosts[j].applications[k].itens[l].id,
                count,
              ),
            );
            count = count + 1;
            correlation.push({ site: i, host: j, application: k, item: l });
          }
        }
      }
    }
  }
  try {
    const response7 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response7.data.length; i++) {
      itens = [];
      for (j = 0; j < response7.data[i].result.length; j++) {
        if (
          response7.data[i].result[j].value == "1" &&
          response7.data[i].result[j].status == "0"
        ) {
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "enum"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = response7.data[i].result[j].description;
          }
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "bin"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = "ALARME";
          }
          zabbixSites[correlation[i].site].hosts[
            correlation[i].host
          ].applications[correlation[i].application].itens[
            correlation[i].item
          ].priority = response7.data[i].result[j].priority;
        }
        zabbixTriggers[response7.data[i].result[j].triggerid] = {
          site: zabbixSites[correlation[i].site].site,
          host:
            zabbixSites[correlation[i].site].hosts[correlation[i].host].name,
          application:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].name,
          item:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].name,
          priority: response7.data[i].result[j].priority,
          description: response7.data[i].result[j].description,
        };
      }
    }
  } catch (e) {
    errors2.push(e);
  }

  localStorage.setItem("sites", JSON.stringify(zabbixSites));

  var apiData = {
    sites: swapSites,
    triggers: zabbixTriggers,
  };

  localStorage.setItem("triggers", JSON.stringify(zabbixTriggers));
  // console.log(zabbixTriggers)
  return apiData;
}

async function AsingZabbixSiteInfo(token) {
  var entities = [];
  var zabbixSites = [];
  var zabbixAlarms = [];
  var zabbixTriggers = [];
  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var request = [],
    request2 = [],
    request3 = [],
    request4 = [];
  var i = 0,
    j = 0,
    k = 0,
    l = 0,
    m = 0;
  var count = 0,
    correlation = [];

  //Get Entities
  try {
    const response = await api.get(
      `${actiDomain}search/entity?forcedisplay[0]=2&forcedisplay[1]=4&forcedisplay[2]=12&forcedisplay[3]=8&forcedisplay[4]=14&range=0-990`,
    );
    entities = response.data.data;
  } catch (e) {
    errors.push(e);
  }

  // entities = JSON.parse(localStorage.getItem('entities'));
  // console.log(entities)
  //Get Zabbix Tokens
  for (i = 0; i < entities.length; i++) {
    if (
      entities[i][4] != null &&
      entities[i][4] &&
      entities[i][8] != null &&
      entities[i][8]
    ) {
      request.push(
        apiRequests.reqLoginZabbix(entities[i][8], entities[i][8], count),
      );
      correlation[count] = i;
      count = count + 1;
    }
  }
  if (request.length > 0) {
    try {
      const response2 = await axios.post(zabbixDomain, request);
      for (j = 0; j < response2.data.length; j++) {
        zabbixSites.push({
          site: entities[correlation[j]][4],
          entity: entities[correlation[j]][8],
          token: response2.data[j].result,
          location_lat: "",
          location_lon: "",
          location: "",
          alarmList: [],
          lastAlarm: "",
          lastAlarmPriority: 0,
          state: entities[correlation[j]][12],
          hosts: [],
          id: j,
        });
      }
    } catch (e) {
      errors2.push(e);
    }
  }

  //Get Site Location
  request = [];
  for (i = 0; i < zabbixSites.length; i++) {
    request.push(
      apiRequests.reqSiteLocZabbix(
        zabbixSites[i].token,
        zabbixSites[i].entity,
        i,
      ),
    );
  }
  if (request.length > 0) {
    try {
      const response3 = await axios.post(zabbixDomain, request);
      // console.log(response3);
      for (i = 0; i < response3.data.length; i++) {
        zabbixSites[i].location_lat =
          response3.data[i].result[0].inventory.location_lat;
        zabbixSites[i].location_lon =
          response3.data[i].result[0].inventory.location_lon;
        zabbixSites[i].location =
          response3.data[i].result[0].inventory.location;
      }
    } catch (e) {
      errors2.push(e);
    }
  }

  var apiData = {
    sites: zabbixSites,
    triggers: zabbixTriggers,
  };
  // console.log("SITES")
  // console.log(zabbixSites)
  localStorage.setItem("sites", JSON.stringify(zabbixSites));
  localStorage.setItem("triggers", JSON.stringify(zabbixTriggers));
  // console.log(zabbixTriggers)
  return apiData;
}

async function AsingZabbixProblems(sites) {
  var zabbixProblems = [];
  var zabbixTriggers = [];
  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var i = 0,
    j = 0,
    k = 0,
    l = 0,
    m = 0,
    date = null,
    dateString = null;
  // console.log(sites);
  zabbixTriggers = JSON.parse(localStorage.getItem("triggers"));
  // console.log(zabbixTriggers);
  //Get Problems
  var request = [];
  var problemsInput = [];
  request.push(apiRequests.reqProblemsZabbix(sites[0].token));

  try {
    const response7 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response7.data.length; i++) {
      problemsInput = response7.data[i].result;
      // console.log(problemsInput);
      for (j = 0; j < response7.data[i].result.length; j++) {
        if (
          zabbixTriggers[problemsInput[j].objectid] != null &&
          zabbixTriggers[problemsInput[j].objectid].priority > 0
        ) {
          if (problemsInput[j].acknowledged > 0) {
            date = new Date(problemsInput[j].acknowledges[0].clock * 1000);
            dateString = date.toLocaleString();
          }
          zabbixProblems.push({
            site: zabbixTriggers[problemsInput[j].objectid].site,
            host: zabbixTriggers[problemsInput[j].objectid].host,
            application: zabbixTriggers[problemsInput[j].objectid].application,
            item: zabbixTriggers[problemsInput[j].objectid].item,
            priority: zabbixTriggers[problemsInput[j].objectid].priority,
            description: zabbixTriggers[problemsInput[j].objectid].description,
            id: problemsInput[j].eventid,
            acknowledges: problemsInput[j].acknowledges,
            clock: problemsInput[j].clock,
            ns: problemsInput[j].ns,
            acknowledged: problemsInput[j].acknowledged == "0" ? "NÃO" : "SIM",
            comment:
              problemsInput[j].acknowledged == "0"
                ? "-"
                : problemsInput[j].acknowledges[0].message +
                  "\nData:" +
                  dateString,
          });
        }
      }
    }
  } catch (e) {
    errors2.push(e);
  }
  return zabbixProblems;
}

async function AsingZabbixUpdateItens(zabbixSite) {
  var entities = [];
  var zabbixSites = [];
  zabbixSites.push(zabbixSite);
  var zabbixAlarms = [];
  var zabbixTriggers = [];
  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var request = [],
    request2 = [],
    request3 = [],
    request4 = [];
  var i = 0,
    j = 0,
    k = 0,
    l = 0,
    m = 0;
  var count = 0,
    correlation = [];

  //Get Itens
  request = [];
  correlation = [];
  count = 0;
  var itens = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        request.push(
          apiRequests.reqItensZabbix(
            zabbixSites[i].token,
            zabbixSites[i].hosts[j].id,
            zabbixSites[i].hosts[j].applications[k].id,
            count,
          ),
        );
        count = count + 1;
        correlation.push({ site: i, host: j, application: k });
      }
    }
  }
  try {
    const response6 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response6.data.length; i++) {
      itens = [];
      for (j = 0; j < response6.data[i].result.length; j++) {
        if (response6.data[i].result[j].units != "hid") {
          if (response6.data[i].result[j].units == "bin") {
            itens.push({
              name: response6.data[i].result[j].name,
              id: response6.data[i].result[j].itemid,
              key: response6.data[i].result[j].key_,
              units: response6.data[i].result[j].units,
              lastvalue: "OK",
              priority: "0",
            });
          } else {
            if (response6.data[i].result[j].units == "enum") {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: "OK",
                priority: "0",
              });
            } else {
              itens.push({
                name: response6.data[i].result[j].name,
                id: response6.data[i].result[j].itemid,
                key: response6.data[i].result[j].key_,
                units: response6.data[i].result[j].units,
                lastvalue: response6.data[i].result[j].lastvalue,
                priority: "0",
              });
            }
          }
        }
      }
      zabbixSites[correlation[i].site].hosts[correlation[i].host].applications[
        correlation[i].application
      ].itens = itens;
    }
  } catch (e) {
    errors2.push(e);
  }

  //Get Triggers
  request = [];
  correlation = [];
  count = 0;
  var triggers = [];
  for (i = 0; i < zabbixSites.length; i++) {
    for (j = 0; j < zabbixSites[i].hosts.length; j++) {
      for (k = 0; k < zabbixSites[i].hosts[j].applications.length; k++) {
        for (
          l = 0;
          l < zabbixSites[i].hosts[j].applications[k].itens.length;
          l++
        ) {
          request.push(
            apiRequests.reqTriggerZabbix(
              zabbixSites[i].token,
              zabbixSites[i].hosts[j].id,
              zabbixSites[i].hosts[j].applications[k].id,
              zabbixSites[i].hosts[j].applications[k].itens[l].id,
              count,
            ),
          );
          count = count + 1;
          correlation.push({ site: i, host: j, application: k, item: l });
        }
      }
    }
  }
  try {
    const response7 = await axios.post(zabbixDomain, request);
    for (i = 0; i < response7.data.length; i++) {
      itens = [];
      for (j = 0; j < response7.data[i].result.length; j++) {
        if (
          response7.data[i].result[j].value == "1" &&
          response7.data[i].result[j].status == "0"
        ) {
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "enum"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = response7.data[i].result[j].description;
          }
          if (
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].units == "bin"
          ) {
            zabbixSites[correlation[i].site].hosts[
              correlation[i].host
            ].applications[correlation[i].application].itens[
              correlation[i].item
            ].lastvalue = "ALARME";
          }
          zabbixSites[correlation[i].site].hosts[
            correlation[i].host
          ].applications[correlation[i].application].itens[
            correlation[i].item
          ].priority = response7.data[i].result[j].priority;
        }
        zabbixTriggers[response7.data[i].result[j].triggerid] = {
          site: zabbixSites[correlation[i].site].site,
          host:
            zabbixSites[correlation[i].site].hosts[correlation[i].host].name,
          application:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].name,
          item:
            zabbixSites[correlation[i].site].hosts[correlation[i].host]
              .applications[correlation[i].application].itens[
              correlation[i].item
            ].name,
          priority: response7.data[i].result[j].priority,
          description: response7.data[i].result[j].description,
        };
      }
    }
  } catch (e) {
    errors2.push(e);
  }
  zabbixSite = zabbixSites[0];
  return zabbixSite;
}

async function AsingZabbixEvents(
  zabbixSite,
  hosts,
  applications,
  date_from,
  date_till,
) {
  var zabbixEvents = [];

  var errors = [],
    errors2 = [],
    errors3 = [],
    errors4 = [];
  var i = 0,
    j = 0,
    k = 0,
    count = 0;
  var priorityConvertion = [
    "INFO",
    "INFO",
    "ATENCAO",
    "MEDIA",
    "ALTA",
    "DESASTRE",
  ];

  //Get Triggers
  var request = [];
  var triggers = [];
  var hostids = [];
  var applicationids = [];

  request.push(
    apiRequests.reqEventsZabbix(
      zabbixSite.token,
      hosts,
      applications,
      date_from,
      date_till,
      0,
    ),
  );

  // console.log(request);

  // for (i = 0; i < zabbixSites.length; i++) {
  //   request.push(apiRequests.reqEventsZabbix(zabbixSites[i].token,11000,i));
  // }
  try {
    var zabbixTriggers = [],
      date = null,
      dateString = null;
    const response7 = await axios.post(zabbixDomain, request);
    zabbixTriggers = JSON.parse(localStorage.getItem("triggers"));

    // console.log(response7);
    //
    // console.log("Data Lenght:"+response7.data.length);
    for (i = 0; i < response7.data.length; i++) {
      // console.log("Result Lenght:"+response7.data[i].result.length);
      for (j = 0; j < response7.data[i].result.length; j++) {
        var date = new Date(response7.data[i].result[j].clock * 1000);
        // console.log(response7.data[i].result[j].clock + ' : ' + date.toLocaleString());
        // console.log(zabbixTriggers);
        // console.log(response7.data[i].result[j].objectid);

        if (zabbixTriggers[response7.data[i].result[j].objectid] != null) {
          // console.log("Site: "+zabbixSites[i].site);
          // console.log(zabbixTriggers[response7.data[i].result[j].objectid].host);
          if (
            zabbixSite.entity ==
            zabbixTriggers[response7.data[i].result[j].objectid].host.substring(
              0,
              zabbixTriggers[response7.data[i].result[j].objectid].host.indexOf(
                "_",
              ),
            )
          ) {
            if (response7.data[i].result[j].acknowledged > 0) {
              date = new Date(
                response7.data[i].result[j].acknowledges[0].clock * 1000,
              );
              dateString = date.toLocaleString();
            }
            zabbixEvents.push({
              site: zabbixSite.site,
              host: zabbixTriggers[
                response7.data[i].result[j].objectid
              ].host.substring(
                zabbixTriggers[
                  response7.data[i].result[j].objectid
                ].host.indexOf("_") + 1,
                zabbixTriggers[response7.data[i].result[j].objectid].host
                  .length,
              ),
              application: zabbixTriggers[
                response7.data[i].result[j].objectid
              ].application.replace(/[^\w\s]/gi, ""),
              item: zabbixTriggers[
                response7.data[i].result[j].objectid
              ].item.replace(/[^\w\s]/gi, ""),
              priority:
                response7.data[i].result[j].value == "1"
                  ? priorityConvertion[
                      zabbixTriggers[response7.data[i].result[j].objectid]
                        .priority
                    ]
                  : "INFO",
              description:
                response7.data[i].result[j].value == "1"
                  ? zabbixTriggers[
                      response7.data[i].result[j].objectid
                    ].description.replace(/[^\w\s]/gi, "")
                  : "Retorno ao normal",
              id: response7.data[i].result[j].eventid,
              acknowledged:
                response7.data[i].result[j].value == "1"
                  ? response7.data[i].result[j].acknowledged == "0"
                    ? "NAO RECONHECIDO"
                    : "RECONHECIDO"
                  : "-",
              clock: date.toLocaleString(),
              ns: response7.data[i].result[j].ns,
              comment:
                response7.data[i].result[j].acknowledged == "0"
                  ? "-"
                  : response7.data[i].result[j].acknowledges[0].message.replace(
                      /[^\w\s]/gi,
                      "",
                    ) +
                    " Data:" +
                    dateString,
            });
          }
          // console.log(zabbixEvents);
        }
      }
    }
  } catch (e) {
    errors2.push(e);
  }
  // console.log("ZabbixEvents Lenght:"+zabbixEvents.length);
  // console.log(zabbixEvents);
  return zabbixEvents;
}

//Post Acknowledge
async function AcknowledgeEventZabbix(site, eventsid, comment) {
  var request = [];

  request.push(
    apiRequests.reqAcknowledgeEventZabbix(site.token, eventsid, comment),
  );

  try {
    const response = await axios.post(zabbixDomain, request);
    // console.log(response);
  } catch (e) {
    errors2.push(e);
  }
}

//Get Item History
async function ItemHistoryZabbix(site, itemids, time_from, limit) {
  var request = [];
  var zabbixItemHistory = [];

  request.push(
    apiRequests.reqItemHistoryZabbix(site.token, itemids, time_from, limit),
  );

  try {
    const response = await axios.post(zabbixDomain, request);
    // console.log(response.data[0].result);
    zabbixItemHistory = response.data[0].result;
  } catch (e) {
    errors2.push(e);
  }

  return zabbixItemHistory;
}
